// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"152":"b79ad9aebcca9542","2485":"56deee5e215d5431","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","7521":"926df25b5f1006bf","8199":"f01407468f07465e","8224":"ae6d8f076ce5c55a"}[chunkId] + ".css";
};